import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Calendar } from 'lucide-react';
import '../../../assets/styles/customer/layout/OurJourneySection.css';

const OurJourneySection = () => {
  const milestones = [
    {
      id: 1,
      year: '2023',
      title: 'The Beginning',
      description: 'MilkFlow was born from a simple idea: modernize local dairy delivery.',
      position: 'left'
    },
    {
      id: 2,
      year: '2023',
      title: 'First 100 Users',
      description: 'Reached our first milestone of active distributors within 3 months.',
      position: 'right'
    },
    {
      id: 3,
      year: '2024',
      title: 'Platform Launch',
      description: 'Launched our full-featured platform with QR tracking and analytics.',
      position: 'left'
    },
    {
      id: 4,
      year: '2024',
      title: 'Expanding Reach',
      description: 'Now serving multiple cities across Pakistan with growing adoption.',
      position: 'right'
    }
  ];

  return (
    <section className="our-journey-section">
      
      {/* Moving Circles Background */}
      <div className="journey-moving-circles">
        <div className="moving-circle circle-1"></div>
        <div className="moving-circle circle-2"></div>
        <div className="moving-circle circle-3"></div>
        <div className="moving-circle circle-4"></div>
      </div>

      {/* Decorative Icons */}
      <div className="journey-decorative-icons">
        <div className="journey-icon icon-1">
          <Calendar size={28} strokeWidth={1.5} />
        </div>
        <div className="journey-icon icon-2">
          <Calendar size={26} strokeWidth={1.5} />
        </div>
      </div>

      <Container>
        
        {/* Section Header */}
        <div className="journey-header text-center">
          <h2 className="journey-title">
            Our <span className="journey-highlight">Journey</span>
          </h2>
          <p className="journey-subtitle">
            Key milestones in our growth
          </p>
        </div>

        {/* Timeline Container */}
        <div className="timeline-container">
          
          {/* Central Vertical Line */}
          <div className="timeline-line"></div>

          {/* Timeline Items */}
          <div className="timeline-items">
            {milestones.map((milestone, index) => (
              <div 
                key={milestone.id}
                className={`timeline-item ${milestone.position}`}
                style={{ animationDelay: `${index * 0.3}s` }}
              >
                
                {/* Timeline Dot */}
                <div className="timeline-dot">
                  <div className="dot-inner"></div>
                  <div className="dot-pulse"></div>
                </div>

                {/* Timeline Content Card (Flag) */}
                <div className="timeline-card">
                  {/* Year Badge */}
                  <div className="timeline-year">
                    <Calendar size={14} />
                    <span>{milestone.year}</span>
                  </div>

                  {/* Card Content */}
                  <h3 className="timeline-card-title">{milestone.title}</h3>
                  <p className="timeline-card-description">{milestone.description}</p>

                  {/* Card Arrow/Pointer */}
                  <div className="card-pointer"></div>
                </div>

              </div>
            ))}
          </div>

        </div>

      </Container>
    </section>
  );
};

export default OurJourneySection;